export const UNITS_IN_STOCK_MAX_DIGITS = 9;
export const UNITS_IN_STOCK_MAX_DECIMAL_PART = 3;
